import { useTranslation } from 'react-i18next'
import { useTranslate } from '@/hooks'
import { BadgeIcon } from '@/ui/icons/badge'
import { useAppSelector } from '@/redux/hooks'

interface LineItemLabelProps {
  subtype: string
  name?: string
  refundMethod?: number
}

export const LineItemLabel = ({
  subtype,
  name,
  refundMethod
}: LineItemLabelProps) => {
  const { translate } = useTranslate()
  const { t } = useTranslation()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  switch (subtype) {
    case 'RDV_SURPLUS':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {translate('RDV_surplus_line_item_text')}{' '}
          {translate(`refund_card_method${refundMethod}_title`)}
        </dt>
      )
    case 'SERVICE_FEE':
      return (
        <dt
          className="text-sm font-normal text-neutral-800"
          dangerouslySetInnerHTML={{
            __html: translate('service_fees_summary_text')
          }}
        />
      )
    case 'ORIGINAL_PROMOTION_BROKEN':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {t('cost_type.ORIGINAL_PROMOTION_BROKEN')}
        </dt>
      )
    case 'ORIGINAL_SHIPPING':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {t('cost_type.ORIGINAL_SHIPPING')}
        </dt>
      )
    case 'EXCHANGE_PROMOTION':
      return (
        <dt className="flex flex-col gap-1">
          <span className="text-sm font-normal text-neutral-800">
            {t('cost_type.EXCHANGE_PROMOTION')}
          </span>
          <span className="flex w-fit items-center gap-1 rounded-sm bg-neutral-100 px-1.5 py-0.5 text-xs font-normal text-neutral-800">
            <BadgeIcon className="-mt-0.5 size-3.5 -rotate-45" />
            {name}
          </span>
        </dt>
      )
    case 'KEEP_YOUR_ITEM':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {translate('kyi_title')}
        </dt>
      )
    case 'INSTANT_EXCHANGE':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {translate('instant_exchange_line_item_text')}
        </dt>
      )
    case 'EXTERNAL_REFUND':
      return (
        <dt className="flex flex-col gap-1">
          <span className="text-sm font-normal text-neutral-800">
            {t('cost_type.EXTERNAL_REFUND')}
          </span>
          {name && (
            <span className="flex w-fit items-center rounded-sm bg-neutral-100 px-1.5 py-0.5 text-xs font-normal text-neutral-800">
              {name}
            </span>
          )}
        </dt>
      )
    case 'PLATFORM_REFUNDABLE_CAP':
      return (
        <dt className="text-sm font-normal text-neutral-800">
          {t('cost_type.PLATFORM_REFUNDABLE_CAP')}
        </dt>
      )
    case 'FREE_RETURN_PROMOTION':
      return (
        <dt className="flex items-center gap-2 text-sm font-semibold text-neutral-800">
          {settings.branding?.title} Cover
        </dt>
      )
    default:
      return <dt className="text-sm font-normal text-neutral-800">{name}</dt>
  }
}
